export enum FileMimeTypeEnum {
    Pdf = 'application/pdf',
    Png = 'image/png',
    Jpg = 'image/jpg',
    Jpeg = 'image/jpeg',
    PlainText = 'text/plain',
    Xls = 'application/vnd.ms-excel',
    Xlsx = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
}
